import ToggleSwitch from '../../Forms/Input/ToggleSwitch';
import { ProductFormValues } from '../../../types/product';

interface Props {
  form: ProductFormValues;
  onChange: <K extends keyof ProductFormValues>(
    field: K,
    value: ProductFormValues[K]
  ) => void;
}

const ProductAdditionalCharges = ({ form, onChange }: Props) => (
  <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
    <div className="rounded-xl border border-stroke bg-gray-2 p-5 dark:border-strokedark dark:bg-meta-4/20">
      <ToggleSwitch
        label="Aplica propina"
        name="tipEligible"
        checked={form.tipEligible}
        onChange={() => onChange('tipEligible', !form.tipEligible)}
      />
      <p className="mt-2 pr-16 text-xs leading-5 text-bodydark2">
        Incluye este producto en la base utilizada para calcular y prorratear la
        propina.
      </p>
    </div>

    <div className="rounded-xl border border-stroke bg-gray-2 p-5 dark:border-strokedark dark:bg-meta-4/20">
      <ToggleSwitch
        label="Aplica turismo/alojamiento 5%"
        name="appliesTourismTax"
        checked={form.appliesTourismTax}
        onChange={() => onChange('appliesTourismTax', !form.appliesTourismTax)}
      />
      <p className="mt-2 pr-16 text-xs leading-5 text-bodydark2">
        Aplica la contribución especial de turismo del 5 % a este producto de
        alojamiento.
      </p>
    </div>
  </div>
);

export default ProductAdditionalCharges;
